import apiClient, { type PagedResponse } from '../client'
import type {
  CompanyResponse,
  CompanyPersonResponse,
  DocumentRequirementResponse,
} from '../models/response'
import type {
  CreateCompanyStep1Request,
  UpdateCompanyStep2Request,
  UpdateCompanyRequest,
  AddCompanyPersonRequest,
} from '../models/request'

const BASE_PATH = '/companies'

export const companiesService = {
  async getAll(params?: {
    page?: number
    pageSize?: number
    search?: string
    businessType?: number
  }): Promise<PagedResponse<CompanyResponse>> {
    return apiClient.get<PagedResponse<CompanyResponse>>(BASE_PATH, params)
  },

  async getById(id: string): Promise<CompanyResponse> {
    return apiClient.get<CompanyResponse>(`${BASE_PATH}/${id}`)
  },

  async getPending(): Promise<CompanyResponse> {
    return apiClient.get<CompanyResponse>(`${BASE_PATH}/pending`)
  },

  async createStep1(data: CreateCompanyStep1Request): Promise<CompanyResponse> {
    return apiClient.post<CompanyResponse, CreateCompanyStep1Request>(`${BASE_PATH}/step1`, data)
  },

  async updateStep2(id: string, data: UpdateCompanyStep2Request): Promise<CompanyResponse> {
    return apiClient.put<CompanyResponse, UpdateCompanyStep2Request>(`${BASE_PATH}/${id}/step2`, data)
  },

  async finalize(id: string): Promise<CompanyResponse> {
    return apiClient.post<CompanyResponse>(`${BASE_PATH}/${id}/finalize`)
  },

  async update(id: string, data: UpdateCompanyRequest): Promise<CompanyResponse> {
    return apiClient.put<CompanyResponse, UpdateCompanyRequest>(`${BASE_PATH}/${id}`, data)
  },

  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },

  async getDocumentRequirements(businessType: number): Promise<DocumentRequirementResponse[]> {
    return apiClient.get<DocumentRequirementResponse[]>(`${BASE_PATH}/document-requirements/${businessType}`)
  },

  async getPersons(id: string): Promise<CompanyPersonResponse[]> {
    return apiClient.get<CompanyPersonResponse[]>(`${BASE_PATH}/${id}/persons`)
  },

  async addPerson(id: string, data: AddCompanyPersonRequest): Promise<CompanyPersonResponse> {
    return apiClient.post<CompanyPersonResponse, AddCompanyPersonRequest>(`${BASE_PATH}/${id}/persons`, data)
  },

  async removePerson(id: string, companyPersonId: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}/persons/${companyPersonId}`)
  },
}
